module.exports = __webpack_public_path__ + "static/media/logo.959a05ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Layout/logo.png
// module id = 1174
// module chunks = 0